import { useState } from 'react';
import { ArrowLeft, ArrowUpRight, Check, ChevronRight } from 'lucide-react';
import { applyLocale, getLocale, LOCALES, type Locale } from '@/lib/locale';

export type UserMenuSection = 'about' | 'language' | 'help';

interface UserMenuSubsectionProps {
  section: UserMenuSection;
  onBack: () => void;
  onNavigate: (destination: string) => void;
}

const TITLES = { about: 'Sobre nós', language: 'Idioma', help: 'Ajuda' } as const;
const ABOUT_LINKS = [
  { label: 'Visitar a Shiba IA', destination: '/' },
  { label: 'Plataforma Shiba IA', destination: '/#recursos' },
  { label: 'Participar da comunidade', destination: 'mailto:contato@shiba.ia.br?subject=Comunidade Shiba IA' },
  { label: 'Termos de Serviço', destination: '/termos' },
  { label: 'Política de Privacidade', destination: '/privacidade' },
] as const;
const HELP_LINKS = [
  { label: 'Central de Ajuda', destination: '/faq' },
  { label: 'Feedback', destination: 'mailto:contato@shiba.ia.br?subject=Feedback sobre a Shiba IA' },
] as const;

/** Drill-down do menu da conta: os mesmos destinos no desktop e no toque. */
export function UserMenuSubsection({ section, onBack, onNavigate }: UserMenuSubsectionProps): JSX.Element {
  const [locale, setLocale] = useState<Locale>(getLocale);
  const links = section === 'about' ? ABOUT_LINKS : HELP_LINKS;

  const chooseLocale = (value: Locale): void => {
    setLocale(value);
    applyLocale(value);
  };

  return (
    <div className="user-menu__subsection">
      <button type="button" role="menuitem" className="user-menu__item user-menu__back" onClick={onBack}>
        <ArrowLeft size={16} aria-hidden="true" /> {TITLES[section]}
      </button>
      <div className="user-menu__divider" role="separator" />
      {section === 'language' ? LOCALES.map((item) => (
        <button
          key={item.value}
          type="button"
          role="menuitemradio"
          aria-checked={locale === item.value}
          className="user-menu__item"
          onClick={() => chooseLocale(item.value)}
        >
          <span>{item.label}</span>
          <span className="user-menu__item-check" aria-hidden="true">{locale === item.value ? <Check size={16} /> : null}</span>
        </button>
      )) : links.map((link) => (
        <button key={link.label} type="button" role="menuitem" className="user-menu__item" onClick={() => onNavigate(link.destination)}>
          <span>{link.label}</span>
          <span className="user-menu__item-check" aria-hidden="true">{link.destination.startsWith('mailto:') ? <ArrowUpRight size={15} /> : <ChevronRight size={15} />}</span>
        </button>
      ))}
    </div>
  );
}
